enum WorkModes {
    Client = 1,
    Server = 2,
    Gateway = 3,
}

export default WorkModes;
